import { render, staticRenderFns } from "./navigationMenu.vue?vue&type=template&id=24fa6536&"
import script from "./navigationMenu.vue?vue&type=script&lang=js&"
export * from "./navigationMenu.vue?vue&type=script&lang=js&"
import style0 from "./navigationMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports